import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface F5RequestImpl {
    readonly password: string;
    readonly management_ip: string;
    readonly username: string;
}
interface F5CreateInputRequest {
    readonly disable_tls_check: boolean;
    readonly password: string;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly content_type: string[];
    readonly management_ip: string;
    readonly name: string;
    readonly store_full_message: boolean;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly username: string;
}
/**
 * Validate user credentials
 */
export function checkCredentials(JSONbody: F5RequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.f5networks.api.F5Resource/f5networks/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new F5 input
 */
export function create(JSONbody: F5CreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.f5networks.api.F5Resource/f5networks/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
